import React from 'react';

import Main from './styles';

const Content = ({ children }) => {
	return(
		<Main>{children}</Main>
	);
};

export default Content;